'use client';

import {VideoPlayer} from '@shared/VideoPlayer/VideoPlayer';
import {VideoObject, WithContext} from 'schema-dts';

import {useIntersectionObserver} from '@web-landing/hooks/useIntersectionObserver';

import styles from './Video.module.scss';

export const Video = ({videoUrl}: {videoUrl: string}) => {
  const isVideoBlockVisible = useIntersectionObserver({
    elementId: 'career_video',
    isValueToggle: false,
  });

  const videoObject: WithContext<VideoObject> = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: 'Карьера в RuStore',
    duration: 'P30S',
    uploadDate: '12.01.2023',
    description: 'Посмотрите, как интересно строить карьеру в RuStore',
    contentUrl: videoUrl,
  };
  return (
    <div id="career_video" className={styles.root}>
      <VideoPlayer
        autoPlay={isVideoBlockVisible}
        videoUrl={videoUrl}
        className={styles.video}
        videoObject={videoObject}
      />
    </div>
  );
};
